// **************** ROUTE CONSTANT START **************************
// General Page Section
export const LOGIN = "/login";
export const DASHBOARD = "/dashboardpanel";
export const GUEST_SIGNATURE = "/dashboardpanel/guest-signature";
export const PREARRIVAL_REGISTRATION =
  "/dashboardpanel/prearrival-registration";
export const DOWNLOADS = "/dashboardpanel/downloads";
export const CHANGE_PASSWORD = "/dashboardpanel/change-password";
// **************** ROUTE CONSTANT END **************************

export const CURRENCY = "$";
